import apiClient from "./config";
import HOMEINSURANCE_ENDPOINTS from "./endpoints/homeInsuranceEndpoints";

const homeInsuranceService = {
  // Post Insurance
  createHomeInsurance: (payload) => {
    return apiClient.post(HOMEINSURANCE_ENDPOINTS.HOME_POST_INSURANCE, payload);
  },
  DownloadHomeInsurancePDF: (data) => {
    return apiClient.post(
      HOMEINSURANCE_ENDPOINTS.DownloadHomeInsurancePDF,
      data,
      {
        responseType: "blob", // <-- Add this!
      }
    );
  },
};

export default homeInsuranceService;
